import { logDispatcher } from "src/app/core/decorators/state.decorators";

export namespace LanguageActions {

  @logDispatcher
  export class GetLanguages {
    static readonly type = '[Languages] GetLanguages';
    constructor() {}
  }

}
